import { Button } from '@material-ui/core';
import { Vehicle } from '../../../types/vehicle';
import { formatCurrency } from '../../../utils';
import styled from 'styled-components';
import { useBuyNowMutation } from 'services/api/alternative-offers';
import { useDispatch } from 'react-redux';
import { modalsToggle, snackShow } from 'actions';
import ConfirmModal from 'components/Modals/ConfirmModal';

type Props = {
  vehicle: Vehicle;
  containerRef?: React.RefObject<HTMLDivElement>;
};

const StyledButton = styled(Button)`
  height: 44px;
  width: calc(100% - 32px);
`;

const Container = styled.div`
  width: calc(100% + 32px);
  margin: -9px -16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(44px + 18px);
`;

export const BuyNowButton = ({ vehicle, containerRef }: Props) => {
  const [buyNowMutation] = useBuyNowMutation();
  const dispatch = useDispatch();

  const handleClick = async () => {
    dispatch(modalsToggle(`confirm-buy-${vehicle.id}`));
  };

  const buyNow = async () => {
    const response = await buyNowMutation(vehicle.id);
    if ('error' in response) {
      dispatch(snackShow({ type: 'error', message: 'Failed to buy vehicle' }));
    } else {
      dispatch(snackShow({ message: 'Successfully bought vehicle' }));
    }
  };

  if (!vehicle.active_alternative_offer) {
    return null;
  }

  const formattedAmount = formatCurrency(vehicle.active_alternative_offer.amount);

  return (
    <Container onMouseOver={e => e.stopPropagation()} ref={containerRef} id={`buy-container-${vehicle.id}`}>
      <StyledButton
        id={`buy-now-${vehicle.id}`}
        onClick={handleClick}
        type="button"
        variant="contained"
        color="primary"
      >
        {`Buy Now for ${formattedAmount}`}
      </StyledButton>
      <ConfirmModal
        title={`Are you sure you want to buy ${vehicle.year} ${vehicle.make} ${vehicle.model} for ${formattedAmount}?`}
        handleSubmit={buyNow}
        submitText={'Buy'}
        modalId={`confirm-buy-${vehicle.id}`}
      />
    </Container>
  );
};
